/**
 * Phone & email checks used by every form (the server applies the same rules).
 * Phone: Indian mobile (10 digits starting 6-9), with or without +91 / 0 / spaces / dashes.
 *        Landlines with STD code (10-11 digits starting 1-5) are also accepted where `landline` is true.
 */
export const PHONE_MSG = "Enter a valid 10-digit mobile number";
export const EMAIL_MSG = "Enter a valid email address";
const EMAIL_RE = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;

export function digitsOf(v) {
  let d = String(v || "").replace(/\D/g, "");
  if (d.length === 12 && d.startsWith("91")) d = d.slice(2);
  else if (d.length === 11 && d.startsWith("0") && /^[6-9]/.test(d.slice(1))) d = d.slice(1);
  return d;
}

export function isPhone(v, { landline = true } = {}) {
  const d = digitsOf(v);
  if (/^[6-9]\d{9}$/.test(d)) return true;
  return landline && /^0?[1-5]\d{8,9}$/.test(String(v || "").replace(/\D/g, "").replace(/^91/, ""));
}

export const isEmail = (v) => EMAIL_RE.test(String(v || "").trim());

/** "" when fine, otherwise the message to show under the field. */
export function phoneError(v, { required = false, landline = true } = {}) {
  if (!String(v || "").trim()) return required ? "Mobile number is required" : "";
  return isPhone(v, { landline }) ? "" : PHONE_MSG;
}
export function emailError(v, { required = false } = {}) {
  if (!String(v || "").trim()) return required ? "Email is required" : "";
  return isEmail(v) ? "" : EMAIL_MSG;
}

/** Keep only characters that can appear in a phone number while typing. */
export const cleanPhoneInput = (v) => String(v || "").replace(/[^\d+\s-]/g, "").slice(0, 16);

/** +91 98765 43210 style display. */
export function prettyPhone(v) {
  const d = digitsOf(v);
  return /^[6-9]\d{9}$/.test(d) ? `+91 ${d.slice(0, 5)} ${d.slice(5)}` : String(v || "");
}

/** Run several checks at once: validate({phone: phoneError(p,{required:true}), email: emailError(e)}) → {} when all good. */
export function collect(map) {
  const out = {};
  Object.entries(map).forEach(([k, msg]) => { if (msg) out[k] = msg; });
  return out;
}
